import { snapshot } from 'valtio'
import format from 'date-fns/format'

import { DEFAULT_LIMIT, buildAxiosInstance } from '../utils/apiUtils'
import { recurringPaymentsProxy } from '../../routes/app/recurring-charges/index/recurringPaymentsProxy'
import { convertFromCentValue } from '../utils/formattingUtils'
import { type RecurringPaymentStatus } from '../types/GlobalRecurringPaymentsStatus'
import { type RecurringPayment } from '../proxies/recurringPaymentProxy'

const buildfetchParams = (): any => {
  const { filters, pagination } = snapshot(recurringPaymentsProxy)
  const params: { [key in string]: string | number | readonly RecurringPaymentStatus[] } = {
    limit: pagination.limit ?? DEFAULT_LIMIT,
    offset: filters.offset
  }
  if (filters.startDate) {
    params.startDate = format(filters.startDate, 'yyyy-MM-dd')
  }
  if (filters.endDate) {
    params.endDate = format(filters.endDate, 'yyyy-MM-dd')
  }
  if (filters.search) {
    params.search = filters.search
  }
  if (filters.sortColumn && filters.sortDirection) {
    params.sortColumn = filters.sortColumn
    params.sortDirection = filters.sortDirection
  }

  if (filters.statuses && filters.statuses.length > 0) {
    params.statuses = [...filters.statuses]
  }
  return params
}

interface FetchRecurringPaymentsArgs {
  displayLoader: boolean
  appendRecords?: boolean
  ignoreRecords?: boolean
}

export async function executeRetrieveRecurringPaymentsSearch ({ displayLoader = true, appendRecords = false, ignoreRecords = false }: FetchRecurringPaymentsArgs): Promise<void> {
  if (displayLoader) { recurringPaymentsProxy.apiCall.loading = true }
  recurringPaymentsProxy.apiCall.error = null
  try {
    const params = buildfetchParams()
    const response = await buildAxiosInstance().post('/api/recurring_payments/search', params)
    if (response.data.error) {
      recurringPaymentsProxy.apiCall.error = response.data.error
      return
    }

    const recentRec: RecurringPayment[] = response.data?.data?.recurringPayments ?? []
    recentRec.forEach((txn: RecurringPayment) => {
      txn.amountCents = convertFromCentValue(txn.amountCents, txn.amountCurrencyType)
    })

    if (appendRecords) {
      recurringPaymentsProxy.recurringPayments = recurringPaymentsProxy.recurringPayments.concat(recentRec)
    } else if (ignoreRecords) {
      recurringPaymentsProxy.exportRecurringPayments = recentRec
    } else {
      recurringPaymentsProxy.recurringPayments = recentRec
    }
    recurringPaymentsProxy.pagination = response.data.data.pagination
  } catch (e) {
    if (e instanceof Error) {
      recurringPaymentsProxy.apiCall.error = e.message
    }
  } finally {
    if (displayLoader) { recurringPaymentsProxy.apiCall.loading = false }
  }
}
